import { produce } from 'immer';
import { useMemo, useState } from 'react';
import { filter, map, Subject } from 'rxjs';
import { match, P } from 'ts-pattern';
import { useSubscription } from '../hooks/useSubscription';
import { BusEvent } from './EditorContext';

export type SideCarState = { letterId: string | undefined };

export type SideCarEvent = { type: 'Open'; id: string } | { type: 'Close' };

const handleSideCarEvent = (action: SideCarEvent) => (state: SideCarState) =>
  produce(state, (draft) => {
    match(action)
      .with({ type: 'Close' }, () => (draft.letterId = undefined))
      .with({ type: 'Open', id: P.select() }, (id) => (draft.letterId = id))
      .exhaustive();

    return draft;
  });

export const useSideCar = (bus$: Subject<BusEvent>) => {
  const [sideCarState, setSideCarState] = useState<SideCarState>({ letterId: undefined });

  const sideCarEvent$ = useMemo(
    () =>
      bus$.pipe(
        filter((e) => e.type === 'SideCar'),
        map((e) => (e as { type: 'SideCar'; event: SideCarEvent }).event)
      ),
    [bus$]
  );

  useSubscription(
    () => sideCarEvent$.subscribe((a) => setSideCarState(handleSideCarEvent(a))),
    [sideCarEvent$]
  );

  return sideCarState;
};
